import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AppService } from "../../../core/services/app.service";

@Injectable({
  providedIn: "root",
})
export class UploadVideoService {
  public file: File;
  public original: string;
  public fileTypes = ["video/mp4"];
  public uploadAPI = AppService.getApiUrl() + "/api/videos/";
  public uploadChunkingAPI = AppService.getApiUrl() + "/api/videos/chunking";
  public deletedPhotoId = null;

  constructor(private router: Router, private http: HttpClient) {}

  public uploadOriginal(formData) {
    return this.http.post(this.uploadChunkingAPI, formData);
  }

  public getVideo(id) {
    return this.http.get(
      this.uploadAPI + id + "?filter[include]=category&filter[include]=customer"
    );
  }

  public updateVideo(id, video) {
    return this.http.put(this.uploadAPI + id, video);
  }

  public delete(id) {
    return this.http.delete(this.uploadAPI + id);
  }
}
